/** Full-viewport flex centering; the visible panel is an inner element so motion never fights positioning. */
export const contactsModalPositionerClass =
  "group fixed inset-0 z-[var(--z-alert)] flex w-auto max-h-none items-center justify-center overflow-hidden border-0 bg-transparent p-4 shadow-none outline-none sm:p-6";

export const contactsModalPanelClass =
  "flex h-fit min-h-0 w-[min(92vw,28rem)] max-h-[min(85dvh,calc(100dvh-env(safe-area-inset-top,0px)-env(safe-area-inset-bottom,0px)-2rem))] flex-col gap-0 overflow-hidden rounded-lg border border-border bg-surface-elevated p-0 shadow-md group-data-[state=open]:animate-dialog-in-mauto group-data-[state=closed]:animate-dialog-out-mauto motion-reduce:animate-none motion-reduce:transition-none";

export const contactsModalHeaderClass = "shrink-0 space-y-2 px-6 pt-6 text-start";

export const contactsModalHeaderCompactClass = "shrink-0 space-y-1.5 px-5 pt-5 text-start";

export const contactsModalBodyClass = "min-h-0 flex-1 overflow-y-auto px-6 py-2 text-start";

export const contactsModalBodyCompactClass = "min-h-0 flex-1 overflow-y-auto px-5 py-2 text-start";

export const contactsModalFooterClass =
  "flex shrink-0 flex-wrap items-center justify-end gap-3 border-t border-border/60 px-6 py-4";

export const contactsModalFooterCompactClass =
  "flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-border/60 px-5 py-3";
